import { Directive, Input, ElementRef, HostListener, Renderer2, Injectable, Inject } from '@angular/core';
import { Sort } from '../shared-services/sort';

@Directive({
    selector: '[appSort]',
    standalone: false
})
@Injectable()
export class SortDirective {

  @Input() appSort: Array<any>;

  constructor(@Inject(ElementRef) private elementRef: ElementRef) { }

  @HostListener("click")
  sortData() {

    const sort = new Sort();

    const elem = this.elementRef.nativeElement;

    const order = elem.getAttribute("data-order");

    const type = elem.getAttribute("data-type");

    const property = elem.getAttribute("data-name");

    if (order === "desc") {
      this.appSort.sort(sort.startSort(property, order, type));
      elem.setAttribute("data-order", "asc");
    } else {
      this.appSort.sort(sort.startSort(property, order, type));
      elem.setAttribute("data-order", "desc");
    }

  }

}